<template>
	<div>
		<div class="bb-most-popular">
			<p class="label">Most Popular:</p>
            <div class="grid g2" role="radiogroup" aria-label="Most popular finishes">
                <div
                    v-for="finish in popular_finishes"
                    :key="finish.id">
                    <button type="button" class="wood-finish"
                        :class="{active : isActive(finish)}"
                        role="radio"
                        :aria-checked="isActive(finish) ? 'true' : 'false'"
                        :aria-label="finish.wood.name + ' Wood ' + finish.finish.name + ' Finish'"
                        @click.prevent="onClick(finish)">
                        <div class="finish" :style="imgStyle(finish.finish)" aria-hidden="true"></div>
                        <p>{{finish.wood.name}} Wood {{finish.finish.name}} Finish</p>
                    </button>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
    import {mapState} from 'vuex';
	export default {
		name : "most-popular",
		components: {

        },
        methods : {
            imgStyle(finish) {
                return `background-image: url(${finish.image.webPath}/200);`;
            },
            /**
             * user clicked on one of the popular finishes
             * @param  {[type]} finish [description]
             * @return {[type]}        [description]
             */
            onClick(selected_finish){
                this.$store.commit('setSelectedPopularFinish',selected_finish);
                // loop through and find matching wood
                let wood = null;
                for(let w in this.woods){
                    wood = this.woods[w];
                    if( wood.id == selected_finish.wood_id){
                        break;
                    }
                }
                // save to store.
                this.$store.commit('setSelectedWood',wood);
                setTimeout(() => {
                    let finish = null;
                    for(let f in this.wood_finishes){
                        finish = this.wood_finishes[f];
                        if( finish.id == selected_finish.finish_id){
                            break;
                        }
                    }
                    this.$store.commit('setSelectedFinish',finish);
                },0);
            },
            /**
             * see if this is the selected finish.
             * @param  {[type]}  finish [description]
             * @return {Boolean}        [description]
             */
            isActive(finish){
                if(this.selected_popular_finish == null) return false;
                return this.selected_popular_finish.id == finish.id;
            }
        },
        computed : {
            ...mapState({
                popular_finishes : state => state.popular_finishes,
                selected_popular_finish : state => state.selected_popular_finish,
                woods : state => state.woods,
                wood_finishes : state => state.wood_finishes,
            })
        }
	}
</script>